import React, { useCallback, useMemo } from 'react';
import { } from 'reactstrap'; // This might be better as just removing the line if no imports are lefte but other files might need it. Actually, reactstrap is purely used for UI. If nothing used, remove line.
import PropTypes from 'prop-types';

/**
 * Teclado Virtual estilo tela touch
 * Orientado ao uso em totens de atendimento
 */
const VirtualKeyboard = ({ onKeyPress, onDelete, onSpace, onClear }) => {
    // Teclado QWERTY simplificado otimizado para busca de nomes
    const rows = useMemo(() => [
        ['Q','W','E','R','T','Y','U','I','O','P'],
        ['A','S','D','F','G','H','J','K','L'],
        ['Z','X','C','V','B','N','M']
    ], []);

    const handleKey = useCallback((key) => {
        onKeyPress?.(key);
    }, [onKeyPress]);

    return (
        <div className="w-100" style={{ maxWidth: "600px", margin: "0 auto" }}>
            {rows.map((row, i) => {
                const rowGaps = "6px";
                return (
                    <div key={i} className="d-flex justify-content-center mb-2" style={{ gap: rowGaps }}>
                        {/* Recuo lateral da Row 2 (meia tecla de cada lado) */}
                        {i === 1 && (
                            <div style={{ flex: "0.5 1 0px", minWidth: "0" }}></div>
                        )}

                        {/* Recuo lateral da Row 3 (duas teclas para alinhar com backspace) */}
                        {i === 2 && (
                            <div style={{ flex: "2 1 0px", minWidth: "0" }}></div>
                        )}

                        {row.map(key => (
                            <button
                                key={key}
                                className="btn shadow-sm d-flex align-items-center justify-content-center fw-bold kiosk-key"
                                style={{ 
                                    flex: "1 1 0px", 
                                    aspectRatio: "1",
                                    minWidth: "0", 
                                    fontSize: "clamp(16px, 2.5vw, 24px)", 
                                    borderRadius: "50%", 
                                    border: "1.5px solid #482712",
                                    padding: 0,
                                    backgroundColor: "#fff",
                                    color: "#482712",
                                    boxShadow: "0 4px 12px rgba(72, 39, 18, 0.06)"
                                }}
                                onClick={() => handleKey(key)}
                            >
                                {key}
                            </button>
                        ))}

                        {/* Botão Apagar ao final da 3ª linha */}
                        {i === 2 && (
                            <button 
                                className="btn shadow-sm d-flex align-items-center justify-content-center text-danger" 
                                style={{ 
                                    flex: "1 1 0px", 
                                    aspectRatio: "1",
                                    minWidth: "0", 
                                    borderRadius: "50%", 
                                    padding: 0,
                                    border: "1.5px solid #dc3545",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(220, 53, 69, 0.08)"
                                }} 
                                onClick={onDelete}
                            >
                                <i className="mdi mdi-backspace-outline" style={{ fontSize: "clamp(18px, 3.5vw, 24px)" }}></i>
                            </button>
                        )}

                        {/* Recuo lateral da Row 2 (meia tecla de cada lado) */}
                        {i === 1 && (
                            <div style={{ flex: "0.5 1 0px", minWidth: "0" }}></div>
                        )}
                    </div>
                );
            })}
            
            {/* Linha Inferior: Controle (Botão Espaço Largo com Altura Alinhada) */}
            <div className="d-flex justify-content-center mt-2 w-100" style={{ gap: "6px" }}>
                <div style={{ flex: "1 1 0px", aspectRatio: "1", minWidth: "0" }}></div>
                <div style={{ flex: "1 1 0px", aspectRatio: "1", minWidth: "0" }}></div>
                <div style={{ flex: "1 1 0px", aspectRatio: "1", minWidth: "0" }}></div>
                <button 
                    className="btn shadow-sm fw-bold text-uppercase d-flex align-items-center justify-content-center kiosk-key" 
                    style={{ 
                        flex: "4 1 0px", 
                        minWidth: "0",
                        borderRadius: "100px", 
                        fontSize: "clamp(12px, 2.2vw, 18px)", 
                        border: "1.5px solid #482712",
                        backgroundColor: "#fff",
                        color: "#482712",
                        boxShadow: "0 4px 12px rgba(72, 39, 18, 0.06)",
                        padding: 0
                    }} 
                    onClick={onSpace}
                    title="Espaço"
                >
                    ESPAÇO
                </button>
                <div style={{ flex: "1 1 0px", aspectRatio: "1", minWidth: "0" }}></div>
                <div style={{ flex: "1 1 0px", aspectRatio: "1", minWidth: "0" }}></div>
                <div style={{ flex: "1 1 0px", aspectRatio: "1", minWidth: "0" }}></div>
            </div>
        </div>
    );
};

VirtualKeyboard.propTypes = {
    onKeyPress: PropTypes.func,
    onDelete: PropTypes.func,
    onSpace: PropTypes.func,
    onClear: PropTypes.func
};

export default VirtualKeyboard;
